export const floatToText = (value: number): string => {
  return '' + value;
};

export const textToFloat = (value: string): number => {
  return parseFloat(value);
};
